<template>
  <router-view />
</template>

<script>
export default {
  name: "Lessons",
  data() {
    return {};
  }
};
</script>